import { FlyerDetailPageFormPositionState } from "./flyer-detail-page-form-position-state.interface";

export function createFlyerDetailPageFormPositionState(): FlyerDetailPageFormPositionState {
  return {
    position: null,
    isLoading: false,
  };
}
